/**
 * codmonStatusView
 * アイコン＋見出し＋説明文を中央配置で表示するステータスビューコンポーネント。
 * 園児未選択、検索結果0件、エラー表示などの空状態表示に使用する。
 *
 * Figmaデザインシステム準拠:
 * https://www.figma.com/design/FQorGKUHehtvwesxj4OfJ4/CoDMON---Design-System?node-id=12052-42263
 *
 * @example
 * <codmon-status-view
 *   icon-name="person-add"
 *   image-size="medium"
 *   heading="まだ園児が登録されていません"
 *   description="左パネルの「園児を追加」ボタンから、園児の登録を進めましょう"
 * ></codmon-status-view>
 *
 * // ボタン付き
 * <codmon-status-view
 *   icon-name="person-add"
 *   image-size="medium"
 *   heading="まだ園児が登録されていません"
 *   description="園児の登録を進めましょう"
 * >
 *   <codmon-button variant="primary" size="medium" on-click="addMember()">
 *     新規作成
 *   </codmon-button>
 * </codmon-status-view>
 *
 * @param {string=} iconName material-iconのアイコン名（省略時はアイコン非表示）
 * @param {string=} imageSize アイコンサイズ（"small" | "medium" | "large" | "x-large"）。デフォルト: "small"
 * @param {string=} heading 見出しテキスト（省略時は非表示）
 * @param {string=} description 説明テキスト（省略時は非表示）
 * @transclude ボタンなどの追加コンテンツを挿入可能
 */
angular.module('inspinia').directive('codmonStatusView', function () {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      iconName: '@?',
      imageSize: '@?',
      heading: '@?',
      description: '@?',
    },
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_status_view.html?${new Date().getTime()}`,
    link: function (scope) {
      // Figma定義: Small=72, Medium=104, Large=180, XLarge=240
      const imageSizes = { small: 72, medium: 104, large: 180, 'x-large': 240 };
      const validSizes = Object.keys(imageSizes);
      const sizeKey = validSizes.includes(scope.imageSize) ? scope.imageSize : 'small';
      scope.imageSizeClass = 'codmon-status-view--' + sizeKey;
      scope.iconDimension = imageSizes[sizeKey];
    },
  };
});
